import { ReportFeatures } from '@hcs/types';

export const REPORT_PERSONALIZATION_HEADER_FEATURES = [
  ReportFeatures.CobrandedReport,
];
